import 'react';
import '../../@emotion/core/dist/emotion-element-04d85134.browser.esm.js';
import '../../@emotion/serialize/dist/serialize.browser.esm.js';
import 'react-dom';
import { S as Select } from './Select-e1cf49ae.browser.esm.js';
export { c as createFilter, a as defaultTheme } from './Select-e1cf49ae.browser.esm.js';
import '../../../_virtual/AutosizeInput.js';
import { m as manageState } from './stateManager-2f2b6f5b.browser.esm.js';

var index = manageState(Select);

export { index as default };
